import withLazyAndSuspense from "@src/utils/lazy";

const CommonRouteMapImobileRouting = {
  NLILogin: {
    component: withLazyAndSuspense(() => import("./NLILogin")),
    path: `/servicing/imobileservice/nli-login`,
  },
  CashWithdrawal: {
    component: withLazyAndSuspense(() =>
      import("./CashWithdrawal/CashWithdrawal")
    ),
    path: `/servicing/imobileservice/cash-withdrawal`,
  },
  RequestDDPO: {
    component: withLazyAndSuspense(() => import("./RequestDDPO/RequestDDPO")),
    path: `/servicing/imobileservice/request-ddpo`,
  },
  NliFundTransfer: {
    component: withLazyAndSuspense(() =>
      import("./FundTransfer/NliFundTransfer")
    ),
    path: `/servicing/imobileservice/fund-transfers`,
  },
  CashDeposit: {
    component: withLazyAndSuspense(() => import("./CashDeposit/CashDeposit")),
    path: `/servicing/imobileservice/cash-deposit`,
  },

  // ! Uncomment in future when prod is signed off by client

  ChequelessWithdrawal: {
    component: withLazyAndSuspense(() => import("./ChequelessWithdrawal/ChequelessWithdrawal")),
    path: `/servicing/imobileservice/chequeless-withdrawal`,
  },
  RTGS: {
    component: withLazyAndSuspense(() => import("./RTGS/RTGS")),
    path: `/servicing/imobileservice/rtgs`,
  },
  NEFT: {
    component: withLazyAndSuspense(() => import("./NEFT/NEFT")),
    path: `/servicing/imobileservice/neft`,
  },
};
export default CommonRouteMapImobileRouting;
